import { axiosLevelTech } from '@/services/axiosConfig';
import { showToast } from '@/services/notifications/toastService';

export async function submitMergeRequest(playerIds: string[]): Promise<void> {
  console.group('SubmitMergeRequest Function');
  console.log('Submitting player IDs:', playerIds);

  try {
    const response = await axiosLevelTech.post('/api/search/AddMergePlayersRequest', { playerIds });
    console.log('API Response:', response.data); // Log the response data

    if (response.data.status === 'Success') {
      showToast('success', response.data.message || 'Players added to merge request successfully!');
    } else {
      showToast('error', response.data.message || 'Failed to add players to merge request.');
      throw new Error(response.data.message ?? 'An unknown error occurred.');
    }
  } catch (error: any) {
    console.error('Error during API call:', error); // Log any errors
    showToast('error', error.response?.data?.message || error.message || 'An error occurred during the merge request.');
    throw new Error(error.message ?? 'An unknown error occurred.');
  } finally {
    console.groupEnd(); // End the group regardless of success or failure
  }
}